import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../component/images/logo.png";

const Navbar = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // =====================
  // On Load – check login
  // =====================
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("currentUser")); // ✅ use same key
    const userId = storedUser?._id;

    if (!userId) {
      setIsLoggedIn(false);
      setUserData(null);
      return;
    }

    // ✅ Fetch full user info from backend
    axios
      .get(`https://rishtey.rishteymatch.in/api2/api/user/${userId}`)
      .then((res) => {
        if (res.data.success && res.data.user) {
          setUserData(res.data.user);
          setIsLoggedIn(true);
          localStorage.setItem("currentUser", JSON.stringify(res.data.user)); // keep consistent
        } else {
          handleLogout();
        }
      })
      .catch(() => handleLogout());
  }, []);

  // =====================
  // Clear cookies
  // =====================
  const clearAllCookies = () => {
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0];
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  };

  // =====================
  // Logout with backend call
  // =====================
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token"); // if using auth token
      if (token) {
        await axios.post(
          "https://rishtey.rishteymatch.in/api2/api/logout",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (err) {
      console.warn("Backend logout failed, still clearing frontend.");
    }

    // Clear frontend storage
    localStorage.clear();
    sessionStorage.clear();
    clearAllCookies();

    setUserData(null);
    setIsLoggedIn(false);
    navigate("/login", { replace: true });
  };

  // =====================
  // Display name
  // =====================
  const displayName =
    userData?.full_name || userData?.name || "User";

  return ( <>
    <nav className="navbar navbar-expand-lg navbar-dark  navbar-fixed shadow px-3 ">
      <Link to="/home" className="navbar-brand fw-bold text-warning d-flex align-items-center">
        <img
          src={logo}
          alt="MySite Logo"
          style={{ height: "40px", marginRight: "8px" }}
        />
     
      </Link>
     
      <div className="ms-auto d-flex align-items-center gap-2">
        {isLoggedIn ? (
          <>
           

            <button 
              className="btn btn-danger btn-sm "
              onClick={handleLogout}
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="btn btn-outline-light btn-sm">
             Login
            </Link>
            <Link
              to="/register"
              className="btn btn-warning btn-sm text-dark"
            >
              Register
            </Link>
          </>
        )}
      </div>
      
    </nav>
 
   </>
  );
};

export default Navbar;
